import React, { useEffect, useState } from "react";

const PaymentDialog = () => {
  const [locale, setLocale] = useState("en"); // idioma por defecto

  useEffect(() => {
    const storedLocale = localStorage.getItem("lang"); // o la clave que uses
    if (storedLocale) {
      setLocale(storedLocale);
    }
  }, []);

  return (
    <div style={{ fontSize: "14px" }}>
      {locale === "es" ? (
        <>
          <p>
            <span
              role="img"
              aria-label="phone"
              style={{ color: "hotpink", marginRight: 6 }}
            >
              📞
            </span>
            Para pagos a capital o múltiples pagos, comuníquese a Cobranza.
          </p>
          <p>
            <b>Mexico</b> 800-964-7246
            <br />
            <b>Otros</b> +52-322-176-1131
          </p>
        </>
      ) : (
        <>
          <p>
            <span
              role="img"
              aria-label="phone"
              style={{ color: "hotpink", marginRight: 6 }}
            >
              📞
            </span>
            For extra principal or multiple payments, contact Accounting.
          </p>
          <p>
            <b>US & Canada</b> 1-866-888-0587
            <br />
            <b>Others</b> +52-322-176-0660
          </p>
        </>
      )}
    </div>
  );
};

export default PaymentDialog;
